import { Component, Inject, InjectionToken } from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';
import { ContactFormComponent } from '../contact-form/contact-form.component';
import { ContactsService } from '@fullyops/domain/contacts/service';
import { Observable, of } from 'rxjs';
import { MiniCompany } from '@fullyops/data/companies/mini-company';
import { Contact, ContactInput } from '@fullyops/data/contacts/contact';

export interface NewContactSidebarInputs {
  company: MiniCompany;
  onSave(createdContact: { id: string; name: string }): void;
  onCancel(): void;
}

export const NEW_CONTACT_SIDEBAR_TOKEN =
  new InjectionToken<NewContactSidebarInputs>('new-contact-sidebar-inputs');

@Component({
  selector: 'fo-new-contact-sidebar',
  imports: [MaterialModule, ContactFormComponent],
  templateUrl: './new-contact-sidebar.component.html',
  styleUrl: './new-contact-sidebar.component.scss',
})
export class NewContactSidebarComponent {
  constructor(
    @Inject(NEW_CONTACT_SIDEBAR_TOKEN)
    protected inputs: NewContactSidebarInputs,
    private service: ContactsService,
  ) {}

  protected initialValue: Contact = {
    name: '',
    jobPosition: '',
    email: '',
    address: '',
    mobileNumber: '',
    notes: '',
    company: this.inputs.company,
  };

  protected companies$: Observable<MiniCompany[]> = of([this.inputs.company]);

  protected onSave(input: ContactInput): void {
    this.service
      .createAndStore(input)
      .subscribe((id) => this.inputs.onSave({ id, name: input.name }));
  }
}
